<script>
  import axios from "axios"

  let apiBase = 'https://vaultapi.scv.lk'
  //let profileName = location.hostname.split(".")[0]
  //if (profileName === "localhost") {
    // profileName = "chinthakawijesooriya"
    // apiBase = 'https://scvdr.com'
  //}


  // let apiBase = 'https://vaultapi.scv.lk'

  // const params = new URLSearchParams(window.location.search);
  // let profileName = params.get("name");


  const profileName = window.location.pathname
      .split("/")
      .filter(Boolean)
      .pop();

  let ax = axios.create({
    baseURL: apiBase + '/api/',
    timeout: 10000,
    headers: { Authorization: "bearer " },
  })

  const getProfileData = (async () => {
    return await ax.get(`employee/doctor-profile/` + profileName)
  })()

  function urlify(text) {
    let urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function(url) {
      return '<a href="' + url + '" target="_blank">' + url + '</a>';
    })
  }

  function displayAvailabilityTimes(times) {
    return times.toString().replace(',', '<br/>')
  }

  let aboutBGImageList = ['../img/profile-banner.jpg', '../img/profile-banner1.jpg', '../img/profile-banner2.jpg']
  function getBGImage(type, URL) {
    if (type === 'random') {
      return aboutBGImageList[Math.floor(Math.random() * aboutBGImageList.length)];
    }
    else if (type === 'banner-1') {
      return '../img/profile-banner.jpg'
    }
    else if (type === 'banner-2') {
      return '../img/profile-banner1.jpg'
    }
    else if (type === 'banner-3') {
      return '../img/profile-banner2.jpg'
    }
    else if (type === 'custom') {
      return apiBase + '/api/image/' + URL + '.jpg'
    }
    else {
      return '../img/profile-banner.jpg'
    }
  }
</script>

{#await getProfileData}
  <div class="pageloader is-bottom-to-top is-active bg-primary">
    <span class="title">Loading</span>
  </div>
{:then data}
  <nav
    class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top"
    id="sideNav">
    <a class="navbar-brand js-scroll-trigger" href="#page-top">
      <span class="d-block d-lg-none mx-0 px-0"> {data.data.Name} </span>
      <span class="d-none d-lg-block">
        {#if data.data.ProfilePicID}
          <img
            class="img-fluid img-profile rounded-circle mx-auto mb-2"
            src="{apiBase}/api/image/{data.data.ProfilePicID}.jpg"
            alt="" />
        {:else}
          <img
            class="img-fluid img-profile rounded-circle mx-auto mb-2"
            src="{apiBase}/images/doctor.svg"
            alt="" />
        {/if}
        <p class="subheading name-card text-white text-capitalize mb-0" style="font-size: 2rem">
          {data.data.Name}
        </p>
        <p class="subheading name-card text-dark text-capitalize" style="line-height: 1rem; background-color: #55aef6; border-radius: .3rem; padding: .5rem 0;">
          <small>{data.data.Designation}</small>
          {#if data.data.Qualifications.length > 0}
            <br><span style="font-size: 16px; font-weight: 100;">
              {#each data.data.Qualifications as qualification, i}
                {qualification.Name}{#if data.data.Qualifications.length !== (i+1)},&nbsp;{/if}
              {/each}
            </span>
          {/if}
        </p>
      </span>
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-toggle="collapse"
      data-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation">
      <span class="navbar-toggler-icon" />
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#about">About</a>
        </li>
        {#if data.data.Qualifications.length > 0}
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#qualifications">Qualifications</a>
          </li>
        {/if}
        {#if data.data.WorkExperiences.length > 0}
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#experience">Experience</a>
          </li>
        {/if}
        {#if data.data.AwardsAndCertificates.length > 0}
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#awards">Awards & Appreciations</a>
          </li>
        {/if}
        {#if data.data.Publications.length > 0}
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#publications">Research & Publications</a>
          </li>
        {/if}
        {#if data.data.OtherURL5}
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="{data.data.OtherURL5}" target="_blank">Patient Education</a>
          </li>
        {/if}
        {#if data.data.Availability.length > 0}
          <li class="nav-item">
            <a class="nav-link js-scroll-trigger" href="#availability">Availability</a>
          </li>
        {/if}
        <li class="nav-item">
          <a class="nav-link js-scroll-trigger" href="#contact">Contact</a>
        </li>
      </ul>
      <p class="text-light small d-block d-md-block d-lg-none pull-right">
        Create your Doctor Profile <a href="{apiBase}/#/sign-up/doctor" target="_blank" title="Create Doctor Profile link">here</a><br/>
        Powered by <a href="{apiBase}" target="_blank" title="Shared Care Vault link">Shared Care Vault</a>
      </p>
    </div>
    <p class="text-light small d-none d-lg-block">
      Create your Doctor Profile <a href="{apiBase}/#/sign-up/doctor" target="_blank" title="Create Doctor Profile link">here</a><br/>
      Powered by <a href="{apiBase}" target="_blank" title="Shared Care Vault link">Shared Care Vault</a>
    </p>
  </nav>

  <div class="container-fluid p-0">
    <!--====================================================
							ABOUT
	======================================================-->
    <section class="resume-section p-3 p-lg-5 d-flex d-column" id="about" style="background-image: url({getBGImage(data.data.BGImageType, data.data.BGImageURL)});">
      <div class="my-auto">
        <h2 class="mb-0">{data.data.Name}</h2>

        {#if data.data.Designation}<div class="subheading">{data.data.Designation}</div>{/if}

        {#if data.data.Qualifications.length > 0}
          <div class="subheading"><small>
            {#each data.data.Qualifications as qualification, i}
              {qualification.Name}{#if data.data.Qualifications.length !== (i+1)},&nbsp;{/if}
            {/each}
          </small></div>
        {/if}

        {#if data.data.Description}<p class="mt-4 text-dark" style="max-width: 500px;">{data.data.Description}</p>{/if}

        {#if data.data.Phone || data.data.Email}
          <div class="contact-box-desc row pt-3">
            <div class="col-md-3">
              <h3><i class="fa fa-phone cl-atlantis"></i> Phone</h3>
              <p><a href="tel::{data.data.Phone}" class="">{data.data.Phone}</a></p>
            </div>
            <div class="col-md-3">
              <h3><i class="fa fa-envelope cl-atlantis"></i> Email</h3>
              <address class="address-details-f">
                <p><a href="mailto:{data.data.Email}" class="">{data.data.Email}</a></p>
              </address>
            </div>
          </div>
        {/if}

        {#if data.data.FacebookURL || data.data.LinkedInURL || data.data.YoutubeURL || data.data.OtherURL1 || data.data.OtherURL2 || data.data.OtherURL3 || data.data.OtherURL4}
          <ul class="list-inline list-social-icons mb-0 mt-4">
            {#if data.data.FacebookURL}
              <li class="list-inline-item">
                <a href={data.data.FacebookURL} target="_blank">
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle fa-stack-2x" />
                    <i class="fab fa-facebook fa-stack-1x fa-inverse" title="Facebook"/>
                  </span>
                </a>
              </li>
            {/if}
            {#if data.data.LinkedInURL}
              <li class="list-inline-item">
                <a href={data.data.LinkedInURL} target="_blank">
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle fa-stack-2x" />
                    <i class="fab fa-linkedin fa-stack-1x fa-inverse" title="LinkedIn"/>
                  </span>
                </a>
              </li>
            {/if}
            {#if data.data.YoutubeURL}
              <li class="list-inline-item">
                <a href={data.data.YoutubeURL} target="_blank">
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle fa-stack-2x" />
                    <i class="fab fa-youtube fa-stack-1x fa-inverse" title="Youtube"/>
                  </span>
                </a>
              </li>
            {/if}
            {#if data.data.OtherURL1}
              <li class="list-inline-item">
                <a href={data.data.OtherURL1} target="_blank">
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle fa-stack-2x" />
                    <i class="ai ai-google-scholar-square ai-stack-1x fa-inverse" title="Google Scholar"/>
                  </span>
                </a>
              </li>
            {/if}
            {#if data.data.OtherURL2}
              <li class="list-inline-item">
                <a href={data.data.OtherURL2} target="_blank">
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle fa-stack-2x" />
                    <i class="fab fa-researchgate fa-stack-1x fa-inverse" title="Research Gate"/>
                  </span>
                </a>
              </li>
            {/if}
            {#if data.data.OtherURL3}
              <li class="list-inline-item">
                <a href={data.data.OtherURL3} target="_blank">
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle fa-stack-2x" />
                    <i class="fas fa-anchor fa-stack-1x fa-inverse" title="SLMC"/>
                  </span>
                </a>
              </li>
            {/if}
            {#if data.data.OtherURL4}
              <li class="list-inline-item">
                <a href={data.data.OtherURL4} target="_blank">
                  <span class="fa-stack fa-lg">
                    <i class="fa fa-circle fa-stack-2x" />
                    <i class="fa fa-globe fa-stack-1x fa-inverse" title="{data.data.OtherURL4}"/>
                  </span>
                </a>
              </li>
            {/if}
          </ul>
        {/if}

        {#if data.data.SLMCNumber}<div class="subheading mt-4 text-dark">SLMC Reg No: {data.data.SLMCNumber}</div>{/if}

      </div>
    </section>

    <!--====================================================
							QUALIFICATION
	======================================================-->
    {#if data.data.Qualifications.length > 0}
      <section class="resume-section p-3 p-lg-5" id="qualifications">
        <div class="row my-auto">
          <div class="col-12">
            <h2 class="text-center">Qualifications</h2>
            <div class="mb-5 heading-border" />
          </div>
          {#if data.data.Qualifications.length > 0}
            <div class="table-responsive mt-4">
              <table class="table table-light" style="box-shadow: rgba(0, 0, 0, 0.21) 2px 2px 2px; border-radius: .25rem;">
                <tbody>
                {#each data.data.Qualifications as qualification}
                  <tr>
                    <td>{qualification.Name}</td>
                    <td>{qualification.University}</td>
                    <td>{qualification.Year}</td>
                  </tr>
                {/each}
                </tbody>
              </table>
            </div>
          {/if}
        </div>
      </section>
    {/if}

    <!--====================================================
							EXPERIENCE
	======================================================-->
    {#if data.data.WorkExperiences.length > 0}
      <section class="resume-section p-3 p-lg-5" id="experience">
        <div class="row my-auto">
          <div class="col-12">
            <h2 class="text-center">Experience</h2>
            <div class="mb-5 heading-border" />
          </div>
          {#each data.data.WorkExperiences as workExperiences}
            <div class="resume-item col-md-6 col-sm-12">
              <div
                class="card mx-0 p-4 mb-5" style="border-color: #17a2b8; box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.21);">
                <div class="resume-content mr-auto">
                  <h4 class="mb-3">{workExperiences.Place}</h4>
                  <p>{workExperiences.Post}</p>
                </div>
                <div class="resume-date text-md-right">
                  <span class="text-primary">{workExperiences.From}</span> to <span class="text-primary">{workExperiences.To}</span>
                </div>
              </div>
            </div>
          {/each}
        </div>
      </section>
    {/if}

    <!--====================================================
							   AWARDS
	======================================================-->
    {#if data.data.AwardsAndCertificates.length > 0}
      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="awards">
        <div class="row my-auto">
          <div class="col-12">
            <h2 class="text-center">Awards & Appreciations</h2>
            <div class="mb-5 heading-border" />
          </div>
          <div class="main-award" id="award-box">
            {#each data.data.AwardsAndCertificates as awardsAndCertificate}
              <div class="award">
                <div class="award-icon" />
                <div class="award-content">
                  <span class="date">{awardsAndCertificate.Year}</span>
                  <h5 class="title">{awardsAndCertificate.Name}</h5>
                  <p class="description">{awardsAndCertificate.Description}</p>
                </div>
              </div>
            {/each}
          </div>
        </div>
      </section>
    {/if}

    <!--====================================================
							EXPERIENCE
	======================================================-->
    {#if data.data.Publications.length > 0}
      <section class="resume-section p-3 p-lg-5" id="publications">
        <div class="row my-auto">
          <div class="col-12">
            <h2 class="text-center">Research & Publications</h2>
            <div class="mb-5 heading-border" />
          </div>
          {#each data.data.Publications as publication}
            <div class="resume-item col-md-6 col-sm-12 ">
              <div
                class="card mx-0 p-4 mb-5" style="border-color: #17a2b8; box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.21);">
                <div class="resume-content mr-auto">
                  <h4 class="mb-3">{publication.Topic}</h4>
                  <p>{publication.Description}</p>
                  <h4 class="mb-3">
                    <small>
                      {publication.Type}, <span class="text-primary">{publication.Year}</span>
                      <br/>{@html urlify(publication.Citation)}
                    </small>
                  </h4>
                </div>
              </div>
            </div>
          {/each}
        </div>
      </section>
    {/if}

    <!--====================================================
							AVAILABILITY
     ======================================================-->
    {#if data.data.Availability.length > 0}
      <section class="resume-section p-3 p-lg-5 d-flex flex-column" id="availability">
        <div class="row my-auto">
          <div class="col-12">
            <h2 class="text-center">Availability</h2>
            <div class="mb-5 heading-border" />
          </div>
          <div class="col-12">
            <div id="accordion">
              {#each data.data.Availability as availability}
                <div class="card">
                  <div class="card-header" id="headingOne">
                    <h5 class="mb-0">
                      <button class="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                        {availability.VPName}
                      </button>
                    </h5>
                  </div>
                  <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordion">
                    <div class="card-body">
                      <div class="table-responsive">
                        <table class="table">
                          <thead class="table-secondary">
                            <tr>
                              <th scope="col">Sunday</th>
                              <th scope="col">Monday</th>
                              <th scope="col">Tuesday</th>
                              <th scope="col">Wednesday</th>
                              <th scope="col">Thursday</th>
                              <th scope="col">Friday</th>
                              <th scope="col">Saturday</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>{#if availability.Sunday}{@html displayAvailabilityTimes(availability.Sunday)}{:else}-{/if}</td>
                              <td>{#if availability.Monday}{@html displayAvailabilityTimes(availability.Monday)}{:else}-{/if}</td>
                              <td>{#if availability.Tuesday}{@html displayAvailabilityTimes(availability.Tuesday)}{:else}-{/if}</td>
                              <td>{#if availability.Wednesday}{@html displayAvailabilityTimes(availability.Wednesday)}{:else}-{/if}</td>
                              <td>{#if availability.Thursday}{@html displayAvailabilityTimes(availability.Thursday)}{:else}-{/if}</td>
                              <td>{#if availability.Friday}{@html displayAvailabilityTimes(availability.Friday)}{:else}-{/if}</td>
                              <td>{#if availability.Saturday}{@html displayAvailabilityTimes(availability.Saturday)}{:else}-{/if}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              {/each}
            </div>
          </div>
        </div>
      </section>
    {/if}

    <!--====================================================
							CONTACT
     ======================================================-->
    <section class="resume-section p-3 p-lg-5 d-flex flex-column">
      <div class="row my-auto" id="contact">
        <div class="col-sm-12 mt-0">
          <div class="contact-cont">
            <h3>Contact Details</h3>
            <div class="heading-border-light"></div>
          </div>
          <div class="contact-cont2">
            {#if data.data.Phone}
              <div class="contact-phone contact-side-desc contact-box-desc">
                <h3><i class="fa fa-phone cl-atlantis fa-2x"></i> Phone</h3>
                <p><a href="tel::{data.data.Phone}" class="">{data.data.Phone}</a></p>
              </div>
            {/if}
            <div class="contact-mail contact-side-desc contact-box-desc">
              {#if data.data.Email}
                <h3><i class="fa fa-envelope cl-atlantis fa-2x"></i> Email</h3>
                <address class="address-details-f">
                  <p><a href="mailto:{data.data.Email}" class="">{data.data.Email}</a></p>
                </address>
              {/if}
              {#if data.data.FacebookURL || data.data.LinkedInURL || data.data.YoutubeURL || data.data.OtherURL1 || data.data.OtherURL2 || data.data.OtherURL3 || data.data.OtherURL4}
                <ul class="list-inline list-social-icons mb-0 mt-5">
                  {#if data.data.FacebookURL}
                    <li class="list-inline-item">
                      <a href={data.data.FacebookURL} target="_blank">
                        <span class="fa-stack fa-lg">
                          <i class="fa fa-circle fa-stack-2x" />
                          <i class="fab fa-facebook fa-stack-1x fa-inverse" title="Facebook"/>
                        </span>
                      </a>
                    </li>
                  {/if}
                  {#if data.data.LinkedInURL}
                    <li class="list-inline-item">
                      <a href={data.data.LinkedInURL} target="_blank">
                        <span class="fa-stack fa-lg">
                          <i class="fa fa-circle fa-stack-2x" />
                          <i class="fab fa-linkedin fa-stack-1x fa-inverse" title="LinkedIn"/>
                        </span>
                      </a>
                    </li>
                  {/if}
                  {#if data.data.YoutubeURL}
                    <li class="list-inline-item">
                      <a href={data.data.YoutubeURL} target="_blank">
                        <span class="fa-stack fa-lg">
                          <i class="fa fa-circle fa-stack-2x" />
                          <i class="fab fa-youtube fa-stack-1x fa-inverse" title="Youtube"/>
                        </span>
                      </a>
                    </li>
                  {/if}
                  {#if data.data.OtherURL1}
                    <li class="list-inline-item">
                      <a href={data.data.OtherURL1} target="_blank">
                        <span class="fa-stack fa-lg">
                          <i class="fa fa-circle fa-stack-2x" />
                          <i class="ai ai-google-scholar-square ai-stack-1x fa-inverse" title="Google Scholar"/>
                        </span>
                      </a>
                    </li>
                  {/if}
                  {#if data.data.OtherURL2}
                    <li class="list-inline-item">
                      <a href={data.data.OtherURL2} target="_blank">
                        <span class="fa-stack fa-lg">
                          <i class="fa fa-circle fa-stack-2x" />
                          <i class="fab fa-researchgate fa-stack-1x fa-inverse" title="Research Gate"/>
                        </span>
                      </a>
                    </li>
                  {/if}
                  {#if data.data.OtherURL3}
                    <li class="list-inline-item">
                      <a href={data.data.OtherURL3} target="_blank">
                        <span class="fa-stack fa-lg">
                          <i class="fa fa-circle fa-stack-2x" />
                          <i class="fas fa-anchor fa-stack-1x fa-inverse" title="SLMC"/>
                        </span>
                      </a>
                    </li>
                  {/if}
                  {#if data.data.OtherURL4}
                    <li class="list-inline-item">
                      <a href={data.data.OtherURL4} target="_blank">
                        <span class="fa-stack fa-lg">
                          <i class="fa fa-circle fa-stack-2x" />
                          <i class="fa fa-globe fa-stack-1x fa-inverse" title="{data.data.OtherURL4}"/>
                        </span>
                      </a>
                    </li>
                  {/if}
                </ul>
              {/if}
            </div>
          </div>
        </div>
      </div>
    </section>

  </div>
{:catch error}
  <div class="container-fluid p-0">
    <div class="row mt-5 pt-5">
      <div class="col-sm-12 col-md-5">
        <h1>404 - Page not found</h1>
        <h4>Looks like you took a wrong turn.</h4>
      </div>
      <div class="col-sm-12 col-md-3 ml-md-4">
        <figure class="image is-4by3">
          <img src="{apiBase}/images/404_Llama.svg" alt="404 - Page not found">
        </figure>
      </div>
    </div>
  </div>
{/await}
